const isRecord = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

const validatePlans = (plans) => {
  if (!isRecord(plans) || !['basic', 'premium'].every((key) => isRecord(plans[key]))) {
    throw new Error('Billing details are temporarily unavailable.');
  }
  Object.values(plans).forEach((plan) => {
    if (typeof plan.name !== 'string'
      || !Number.isInteger(plan.amount_cents)
      || typeof plan.blurb !== 'string') {
      throw new Error('Billing details are temporarily unavailable.');
    }
  });
  return plans;
};

const validatePlannedCatalog = (catalog) => {
  if (!isRecord(catalog)
    || catalog.contract !== 'planned-commercial-catalog-v1'
    || catalog.status !== 'PLANNED'
    || catalog.human_beta_runtime_active !== false
    || catalog.purchasable !== false
    || catalog.live_execution_authorized !== false
    || !Array.isArray(catalog.plans)
    || catalog.plans.length !== 3) {
    throw new Error('Billing details are temporarily unavailable.');
  }

  const expectedIds = ['free', 'trader', 'premium'];
  catalog.plans.forEach((plan, index) => {
    if (!isRecord(plan)
      || plan.id !== expectedIds[index]
      || typeof plan.name !== 'string'
      || typeof plan.positioning !== 'string'
      || !Number.isInteger(plan.monthly_target_cents)
      || !Number.isInteger(plan.annual_target_cents)
      || !Number.isInteger(plan.planned_active_bot_limit)
      || !Array.isArray(plan.planned_features)
      || !plan.planned_features.every((feature) => typeof feature === 'string')
      || typeof plan.planned_live_availability !== 'boolean'
      || plan.status !== 'PLANNED'
      || plan.human_beta_runtime_active !== false
      || plan.purchasable !== false
      || plan.live_execution_authorized !== false) {
      throw new Error('Billing details are temporarily unavailable.');
    }
  });
  return catalog;
};

export const normalizeBillingPlans = (value) => {
  if (!isRecord(value) || typeof value.payments_enabled !== 'boolean') {
    throw new Error('Billing details are temporarily unavailable.');
  }
  const normalized = {
    plans: validatePlans(value.plans),
    payments_enabled: value.payments_enabled,
    billing_environment: value.billing_environment === 'TEST' ? 'TEST' : null,
  };
  if (value.planned_catalog !== undefined) {
    normalized.planned_catalog = validatePlannedCatalog(value.planned_catalog);
  }
  return normalized;
};

export const normalizeBillingSubscription = (value) => {
  if (!isRecord(value)
    || !['free', 'basic', 'premium'].includes(value.plan)
    || !Array.isArray(value.subscriptions)
    || !value.subscriptions.every((subscription) => (
      isRecord(subscription)
      && typeof subscription.plan === 'string'
      && typeof subscription.status === 'string'
    ))) {
    throw new Error('Billing details are temporarily unavailable.');
  }
  return {
    ...normalizeBillingPlans(value),
    plan: value.plan,
    subscriptions: value.subscriptions,
    entitlements: {
      premium_backtesting: isRecord(value.entitlements)
        && typeof value.entitlements.premium_backtesting === 'boolean'
        ? value.entitlements.premium_backtesting
        : value.plan === 'premium',
      public_disclosure_alerts: isRecord(value.entitlements)
        && typeof value.entitlements.public_disclosure_alerts === 'boolean'
        ? value.entitlements.public_disclosure_alerts
        : value.plan === 'premium',
    },
    entitlement_contract: typeof value.entitlement_contract === 'string'
      ? value.entitlement_contract
      : 'legacy-plan-presentation',
  };
};
